/** Automatisch angelegte Herkunftsbetriebe ohne Pass-Namen: „VVVO“ + 15 Ziffern. */
export function isVvvoPlaceholderBezeichnung(bezeichnung?: string | null): boolean {
    return /^VVVO\s+\d{15}$/.test((bezeichnung || '').trim());
}

export interface Betriebskontakt {
    kontakt_id?: number;
    benutzer_id: number;
    kunde_id: number;
    favorit: number;
    ist_kunde: number;
    bezeichnung: string;
    zusatz?: string;
    vvvo: string;
    email?: string;
    telefon_1?: string;
    telefon_2?: string;
    mobil_1?: string;
    mobil_2?: string;
    strasse?: string;
    plz?: string;
    ort?: string;
    ortsteil?: string;
    bezeichnung_final: string;
    zusatz_final?: string;
    strasse_final?: string;
    plz_final?: string;
    ort_final?: string;
    ortsteil_final?: string;
    betriebsart_id?: number;
    betriebsart_bezeichnung?: string;
    bereits_kontakt?: number;
    erstellt?: string;
    erstellt_von?: number;
    editiert?: string;
    editiert_von?: number;
    // Erweiterte Eigenschaften für die UI
    cardConfig?: any; // Individuelle Config für die Kontakt-Card
}

export interface BetriebSuchResult {
    kunde_id?: number;
    betrieb_id?: number;
    bezeichnung: string;
    zusatz?: string;
    vvvo: string;
    email?: string;
    telefon_1?: string;
    telefon_2?: string;
    mobil_1?: string;
    mobil_2?: string;
    strasse?: string;
    plz?: string;
    ort?: string;
    ortsteil?: string;
    bezeichnung_final: string;
    zusatz_final?: string;
    strasse_final?: string;
    plz_final?: string;
    ort_final?: string;
    ortsteil_final?: string;
    bereits_kontakt?: number; // Optional, da nicht von der Standard-API bereitgestellt
    kontakt_id?: number;
    benutzer_id?: number;
    erstellt_von?: number;
    favorit?: number;
    ist_kunde?: number;
    betriebsart_id?: number;
}

// Interface für benutzer_betriebskontakte_tierliste API
export interface BetriebskontaktTierliste {
    id: number;
    kontakt_id: number;
    tierliste_id: number;
    aktiv: boolean;
    bemerkung?: string;
    erstellt: string;
    erstellt_von: number;
    editiert?: string;
    editiert_von?: number;
    geloescht: number;
    kunde_id: number;
    bezeichnung: string; // Direkt von benutzer_betriebskontakte
    zusatz?: string; // Direkt von benutzer_betriebskontakte
    vvvo: string; // Direkt von benutzer_betriebskontakte
    tierliste_id_check: number;
    tierliste_kommentar?: string;
}
